// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"612":"3022ec69","854":"dd7710f8"}[chunkId] + ".chunk.js";
};